const TASK_AGENT_NAMES = ["Maya", "Theo", "Nora", "Eli", "Iris", "Owen", "Lena", "Kai"] as const;

export function stableTaskAgentName(threadId: string): string {
  const hash = stableTaskAgentHash(threadId);
  return TASK_AGENT_NAMES[hash % TASK_AGENT_NAMES.length] ?? TASK_AGENT_NAMES[0];
}

export function stableTaskAgentNumber(threadId: string): number {
  return (stableTaskAgentHash(threadId) % 999) + 1;
}

function stableTaskAgentHash(threadId: string): number {
  let hash = 0;
  for (const character of threadId) {
    hash = (hash * 31 + character.charCodeAt(0)) >>> 0;
  }
  return hash;
}
